// extracted by mini-css-extract-plugin
export var card = "PartnerSuccessSection-module__card___HxcDo";
export var cardGlow = "PartnerSuccessSection-module__cardGlow___CU02x";
export var cardGlowClip = "PartnerSuccessSection-module__cardGlowClip___9b68k";
export var caseContent = "PartnerSuccessSection-module__caseContent___8-UTE";
export var caseFooter = "PartnerSuccessSection-module__caseFooter___XxTCL";
export var caseGame = "PartnerSuccessSection-module__caseGame___5YWnn";
export var caseHeader = "PartnerSuccessSection-module__caseHeader___t0X-r";
export var caseHeaderText = "PartnerSuccessSection-module__caseHeaderText___3ALJR";
export var caseKeyArt = "PartnerSuccessSection-module__caseKeyArt___sBq5U";
export var caseLogo = "PartnerSuccessSection-module__caseLogo___aFv+X";
export var caseStudio = "PartnerSuccessSection-module__caseStudio___oZHvq";
export var caseTileTall = "PartnerSuccessSection-module__caseTileTall___rUW2z";
export var caseTileWide = "PartnerSuccessSection-module__caseTileWide___kXhg4";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var grid = "PartnerSuccessSection-module__grid___2rl-q";
export var section = "PartnerSuccessSection-module__section___MW0iq";
export var statDescription = "PartnerSuccessSection-module__statDescription___1WlpO";
export var statLabel = "PartnerSuccessSection-module__statLabel___QTME+";
export var statNumber = "PartnerSuccessSection-module__statNumber___fhCHV";
export var statTile = "PartnerSuccessSection-module__statTile___D97xH";
export var statsRow = "PartnerSuccessSection-module__statsRow___AP-VT";